import { HaPatientimport } from "./HaPatientImport.model";

export class FinalPatientSubmitModal{
    constructor(
            private acceptedPatients:HaPatientimport[],
            private eaLogid:string


    ){}
}